import React from "react";
import { NavigationStepsAll } from "../../components/navbars/navbar_all";
import CoquillesTableMultiOtTag from "../../components/counter_multi_ottag";
import { API_URL } from "../../url_config";

const ReportingTetraSaeAll = () => {
  return (
    <div style={{ 
      padding: "20px", 
      backgroundColor: "#fff", 
      minHeight: "100vh" 
    }}>
      <NavigationStepsAll selectedKey="reporting_tetra_sae" />

      <div style={{ 
        marginTop: "20px", 
        marginBottom: "20px", 
        paddingBottom: "16px",
        borderBottom: "1px solid #d9d9d9"
      }}>
        <h2 style={{ 
          margin: 0, 
          fontSize: "18px", 
          fontWeight: "600", 
          color: "#262626"
        }}>
          Reporting Bascule
        </h2>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 600, 
          color: '#262626',
          marginBottom: '12px',
          paddingLeft: '8px',
          borderLeft: '4px solid #1890ff'
        }}>
          TETRA BUS
        </h3>
        <CoquillesTableMultiOtTag
          baseUrl={`${API_URL}/validations/counter/tetra_bus/`}
          labelAll="Nb PO TETRA DSP"
          labelOk="Nb PO TETRA OK"
          labelNok="Nb PO TETRA KO"
        />
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 600, 
          color: '#262626',
          marginBottom: '12px',
          paddingLeft: '8px',
          borderLeft: '4px solid #1890ff'
        }}>
          SAE-TR
        </h3>
        <CoquillesTableMultiOtTag
          baseUrl={`${API_URL}/validations/counter/po_siel/`}
          labelAll="Nb lignes DSP"
          labelOk="Nb lignes OK"
          labelNok="Nb lignes KO"
          labelExtra="Nb lignes avec IV indispo"
          showExtra={true}
        />
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 600, 
          color: '#262626',
          marginBottom: '12px',
          paddingLeft: '8px',
          borderLeft: '4px solid #1890ff'
        }}>
          AD premiers sortants par ligne
        </h3>
        <CoquillesTableMultiOtTag
          baseUrl={`${API_URL}/validations/counter/geolocalisation/`}
          labelAll="Nb lignes DSP"
          labelOk="Nb lignes OK"
          labelNok="Nb lignes KO"
        />
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          fontSize: '16px', 
          fontWeight: 600, 
          color: '#262626',
          marginBottom: '12px',
          paddingLeft: '8px',
          borderLeft: '4px solid #1890ff'
        }}>
          Tests radio
        </h3>
        <CoquillesTableMultiOtTag
          baseUrl={`${API_URL}/validations/counter/tests_ad/`}
        />
      </div>
    </div>
  );
};

export default ReportingTetraSaeAll;
